import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { FETCH_ASSETS_URL } from 'appenv';
import FileArrow from 'components/icons/FileArrow';

const tanShelfImg = `${FETCH_ASSETS_URL}/assets/booths/tan-shelf.png`;

const StyledImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const ArrowContainer = styled.div`
  position: absolute;
  left: 22px;
  top: 24px;
`;

interface TanShelfProps {
  hasAttachment: boolean;
}

const TanShelf: React.FC<TanShelfProps> = ({ hasAttachment }: TanShelfProps) => {
  const { themeColor } = useSelector((state) => state.eventConfigs);

  return (
    <>
      <StyledImg src={tanShelfImg} />
      {hasAttachment && (
        <ArrowContainer>
          <FileArrow color={themeColor as any} width={40} height={40} />
        </ArrowContainer>
      )}
    </>
  );
};

TanShelf.propTypes = {
  hasAttachment: PropTypes.bool,
};

TanShelf.defaultProps = {
  hasAttachment: false,
};

export default TanShelf;
